import './src/styles/vendors/normalize.scss'
import './src/styles/vendors/tippy.scss'
import './src/styles/vendors/swiper.scss'
import './src/styles/vendors/code-theme.scss'
import './src/styles/global-styles.scss'
import './src/styles/custom-properties.scss'

import React from 'react'
import AppProviders from './src/AppProviders'
import { PreviewProvider } from './src/context/PreviewContext'
import { consolePromotionMessage } from './src/helpers/consolePromotionMessage'
import { registerWebMcpTools } from './src/helpers/webMcp'
import { initNavClickTracking } from './src/helpers/navClickTracking'
import { URL } from './src/constants/site'
import { navigate } from 'gatsby'

const brazilRegulationsPath = '/blog/geolocation-brazil-gambling-regulations/'

async function getUserCountry() {
  try {
    const response = await fetch('/api/get-country/')
    const data = await response.json()
    return data.country
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching country data:', error)
    return null
  }
}

const SAFARI_REPRO_PATH = '/safari-repro/'

export const wrapPageElement = ({ element, props }) => {
  if (props?.path === SAFARI_REPRO_PATH) {
    return element
  }
  return (
    <PreviewProvider isPreview={false}>
      <AppProviders>{element}</AppProviders>
    </PreviewProvider>
  )
}

// Mitigate flickering on blog post
export const onPreRouteUpdate = async ({ location }) => {
  if (location.pathname !== brazilRegulationsPath) {
    return
  }

  const userCountry = await getUserCountry()

  if (userCountry === 'BR') {
    navigate('/blog/geolocation-brazil-gambling-regulations-br/', { replace: true })
  }
}

export const onClientEntry = () => {
  registerWebMcpTools()
  initNavClickTracking()
}

export const onInitialClientRender = () => {
  consolePromotionMessage(`Like breaking things to see how they work? Join us: ${URL.careersConsoleLogUrl}`)
  consolePromotionMessage(`Have a great day! 🫶🏻`)
}
